import { Button, Card, Col, ConfigProvider, Form, Input, Row } from "antd";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import RadioField from "../shared/RadioField";
import InputField from "../shared/InputField";
import handleRsponse from "../../helper/handleRsponse";
import basicInfoRepo from "../../repository/basicInfoRepo";
import SelectField from "../shared/SelectField";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import seriallRepo from "../../repository/serialRepo";
import NewRadioField from "../shared/NewRadioField";
import Utility, { notifyPlacement, notifyType } from "../../helper/utility";
import Captcha from "../shared/Captcha";
const RegisterServiceQrCode = (props) => {
  const [registerResult, setRegisterResult] = useState("");
  const [isSuccess, setIssuccess] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);
  const [productCodeList, setProductList] = useState([]);
  const [currentproduct, setCurrentProduct] = useState({});
  const [isRequiredRegionParish, setIsRequiredRegionParish] = useState(false);
  const [requiredNationalCode, setRequiredNationalCode] = useState(true);
  const [provinceList, setProvinceList] = useState([]);
  const [cityList, setCityList] = useState([]);
  const [regionList, setRegionList] = useState([]);
  const [parishList, setParishList] = useState([]);
  const { id } = useParams();
  const [captchaValue, setCaptchaValue] = useState("");
  const [form] = Form.useForm();
  useEffect(() => {
    handleRsponse.handleAxios(
      basicInfoRepo.getList(`typeId=1&parentId=0`),
      fillProvince,
      setIsLoaded
    );
  }, []);


  const onFinish = (values) => {
    if (values.captcha !== captchaValue) {
      alert("Captcha incorrect!");
      return;
    }
    const model = {
      ...currentproduct,
      ...values,
      regionId: values.regionId || 0,
      parishId: values.parishId || 0,
    };
    console.log("Final Model:", model);
    handleRsponse.handleAxios(
      seriallRepo.registerService(model),
      aftersave,
      setIsLoaded
    );
  };
  const aftersave = (response) => {
    if (response.status === 200) {
      //console.log(response, 'responseData');
      if (response.data.isSuccess) {
        Utility.openNotification(
          notifyType.success,
          notifyPlacement.bottomLeft,
          "موفق",
          response.data.data
        );
        setIssuccess(true);
        setRegisterResult(response.data.data);
      } else
        Utility.openNotification(
          notifyType.error,
          notifyPlacement.bottomLeft,
          "خطا",
          response.data.message
        );
    } else {
      if (response.status == 400) {
        Utility.openNotification(
          notifyType.error,
          notifyPlacement.bottomLeft,
          response.data.data.title,
          response.data.data.errors
        );
      }
    }
  };
  const fillProvince = (response) =>
    setProvinceList(handleRsponse.getResponse(response));

  const fillCity = (provinceId) => {
    form.setFieldsValue({ cityId: null });
    if (provinceId === undefined) {
      setCityList([]);
      return
    }

    handleRsponse.handleAxios(
      basicInfoRepo.getList(`typeId=2&parentId=${provinceId}`),
      (response) => setCityList(handleRsponse.getResponse(response)),
      setIsLoaded
    );
  }

  const fillRegion = (cityId) => {
    form.setFieldsValue({ regionId: null });
    if (cityId === undefined) {
      setRegionList([]);
      return;
    }

    const allocateAdressbyRegion = cityList.find(x => x.id == cityId).allocateAdressbyRegion;
    setIsRequiredRegionParish(allocateAdressbyRegion);
    handleRsponse.handleAxios(
      basicInfoRepo.getList(`typeId=3&parentId=${cityId}`),
      (response) => setRegionList(handleRsponse.getResponse(response)),
      setIsLoaded
    );
  };

  const fillParish = (regionId) => {
    form.setFieldsValue({ parishId: null });
    if (regionId === undefined) {
      setParishList([]);
      return;
    }

    handleRsponse.handleAxios(
      basicInfoRepo.getList(`typeId=4&parentId=${regionId}`),
      (response) => setParishList(handleRsponse.getResponse(response)),
      setIsLoaded
    );
  }

  return (
    <div
      style={{
        paddingBottom: "50px",
        position: "relative",
        display: "block",
      }}
    >
      {!isSuccess ? (
        <ConfigProvider direction="rtl">
          <Card className="festival">
            <Form
              form={form}
              onFinish={onFinish}
              initialValues={currentproduct}
            >
              <Row>

                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                  <InputField
                    name="serialNo"
                    label="سریال"
                    disabled={false}
                    req={true}
                    placeholder="سریال دستگاه"
                  />
                </Col>
                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                  <InputField
                    name="nationalCode"
                    label="کد ملی"
                    maxLength={10}
                    req={requiredNationalCode}
                    placeholder="کد ملی"
                  />
                </Col>
                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                  <NewRadioField
                    name="serviceTypeId"
                    label="نوع سرویس"
                    handleParent={(value) => {
                      setRequiredNationalCode(value.target.value == "3");
                    }}
                  />
                </Col>
                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                  <InputField
                    name="mobile"
                    label="موبایل"
                    customRules={[
                      {
                        pattern: new RegExp(
                          "09[0-909][0-9]-?[0-9]{3}-?[0-9]{4}"
                        ),
                        message: "شماره موبایل صحیح نمی باشد",
                      },
                    ]}
                    req={true}
                    placeholder="موبایل"
                  />
                </Col>
                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                  <InputField
                    name="mobile2"
                    label="2موبایل"
                    req={false}
                    placeholder="2موبایل"
                    customRules={[
                      {
                        pattern: new RegExp(
                          "09[0-909][0-9]-?[0-9]{3}-?[0-9]{4}"
                        ),
                        message: "شماره موبایل صحیح نمی باشد",
                      },
                    ]}
                  />
                </Col>

                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                  <InputField
                    name="firstName"
                    label="نام"
                    req={false}
                    placeholder="نام"
                  />
                </Col>
                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                  <InputField
                    name="lastName"
                    label="نام خانوادگی"
                    req={true}
                    placeholder="نام خانوادگی"
                  />
                </Col>
                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                  <SelectField
                    name="provinceId"
                    label="استان"
                    placeholder="استان خود را انتخاب نمایید"
                    list={provinceList}
                    handleParent={(value) => {
                      fillCity(value);
                    }}
                    isRequired={true}
                  />
                </Col>
                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                  <SelectField
                    name="cityId"
                    label="شهر"
                    placeholder="شهر خود را انتخاب نمایید"
                    list={cityList}
                    handleParent={(value) => {
                      fillRegion(value);
                    }}
                    isRequired={true}
                  />
                </Col>
                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                  <SelectField
                    name="regionId"
                    label="منطقه"
                    placeholder="منطقه خود را انتخاب نمایید"
                    handleParent={(value) => {
                      fillParish(value);
                    }}
                    list={regionList}
                    isRequired={isRequiredRegionParish}
                  />
                </Col>
                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                  <SelectField
                    name="parishId"
                    label="محله"
                    placeholder="محله خود را انتخاب نمایید"
                    list={parishList}
                    isRequired={isRequiredRegionParish}
                  />
                </Col>
                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                  <InputField
                    name="address"
                    label="آدرس"
                    placeholder="آدرس"
                    inputType="TextArea"
                  />
                </Col>
                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                  <InputField
                    name="comment"
                    label="توضیحات"
                    placeholder="توضیحات"
                    inputType="TextArea"
                  />
                </Col>

                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                  <br />
                  <Row>
                    <Col xs={24} sm={24} md={12} lg={4} xl={4}>
                      <div style={{ display: 'inline-block' }}>
                        <Captcha onChange={setCaptchaValue} />
                      </div>
                    </Col>
                    <Col xs={24} sm={24} md={12} lg={4} xl={4}>
                      <Form.Item style={{ display: 'flex', textAlign: 'left' }} name="captcha" rules={[{ required: true, message: 'لطفا کد مشاهده شده در تصویر را وارد نمایید' }]}>
                        <Input dir="ltr" style={{ direction: "ltr", width: '80%', display: 'inline-block', position: 'relative' }} placeholder="کد مشاهده شده در تصویر را وارد نمایید" />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={12} lg={4} xl={4}>
                      <Form.Item>
                        <Button type="primary" danger htmlType="submit" >
                          ثبت
                        </Button>
                      </Form.Item>
                    </Col>
                  </Row>



                </Col>




              </Row>
            </Form>
            {!isLoaded ? <span>منتظر بمانید...</span> : ""}
          </Card>
        </ConfigProvider>
      ) : (
        <center>
          <br />
          <p style={{ color: '#000' }}>باتشکر از شما</p>
          <p style={{ color: '#000' }}>
            <strong>{registerResult}</strong>
          </p>
        </center>
      )}
    </div>
  );
};
const mapStateToProps = (state) => ({});
export default connect(mapStateToProps, null)(RegisterServiceQrCode);
